// extracted by mini-css-extract-plugin
module.exports = {"section-list":"src-components-molecules-SectionList-___style__section-list___RaHQ-","item":"src-components-molecules-SectionList-___style__item___11rU0"};